import React, { useState } from "react";

const Filter = () => {
  const [price, setPrice] = useState([0, 32]);

  const handlePriceChange = (e, index) => {
    const newPrice = [...price];
    newPrice[index] = e.target.value;
    setPrice(newPrice);
  };

  return (
    <div className="md:w-full xl:w-72 border rounded-lg p-4 text-sm">
    <h2 className="font-semibold mb-2">Bộ lọc</h2>
  
    {/* Tình trạng hàng */}
    <div className="mb-4 space-y-2">
      <h3 className="font-semibold">Tình trạng hàng</h3>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Còn hàng (6)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Hết hàng (0)
      </label>
    </div>
  
    {/* Danh mục */}
    <div className="mb-4 space-y-2">
      <h3 className="font-semibold">Danh mục</h3>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Rau củ tươi & đông lạnh (2)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Trái cây & rau củ (3)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Nước chấm rau củ (3)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Rau củ trộn sẵn (1)
      </label>
    </div>
  
    {/* Loại sản phẩm */}
    <div className="mb-4 space-y-2">
      <h3 className="font-semibold">Loại sản phẩm</h3>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Rau củ (3)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Rau củ (3)
      </label>
    </div>
  
    {/* Bộ lọc khác */}
    <div className="mb-4 space-y-2">
      <h3 className="font-semibold">Bộ lọc khác</h3>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Thực phẩm (1)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Rau củ (6)
      </label>
    </div>
  
    {/* Thương hiệu */}
    <div className="mb-4 space-y-2">
      <h3 className="font-semibold">Thương hiệu</h3>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Rau củ (2)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> Rau củ (4)
      </label>
    </div>
  
    {/* Giá */}
    <div className="mb-4 space-y-2">
      <h3 className="font-semibold">Giá</h3>
      <p className="text-gray-500 text-xs mb-2">
        Giá cao nhất là ${price[1]}.00
      </p>
      <div className="flex gap-2">
        <input
          type="number"
          value={price[0]}
          onChange={(e) => handlePriceChange(e, 0)}
          className="border rounded px-2 py-1 w-16"
        />
        <span> - </span>
        <input
          type="number"
          value={price[1]}
          onChange={(e) => handlePriceChange(e, 1)}
          className="border rounded px-2 py-1 w-16"
        />
      </div>
    </div>
  
    {/* Khối lượng */}
    <div className="space-y-2">
      <h3 className="font-semibold">Khối lượng</h3>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> 100g (2)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> 250g (3)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> 500g (6)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> 1kg (3)
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" /> 2kg (1)
      </label>
    </div>
  </div>
  );
};

export default Filter;
